import React from "react";
import { Button, Modal, Header, Label } from "semantic-ui-react";
import moment from "moment";

const styles = {
	commentsList: {
		maxHeight: "100px",
		overflow: "auto",
		padding: "5px",
	},
	commentContainer: {
		margin: "3px 0",
		maxHeigth: "150px",
		border: "1px solid whitesmoke",
		backgroundColor: "white",
		display: "flex",
		justifyContent: "space-between",
		padding: "3px 6px",
		borderRadius: "8px",
	},
	commentHeader: {
		display: "flex",
		justifyContent: "flex-end",
	},
	time: {
		color: "#d1b8b8",
		fontSize: "0.8em",
	},
	comment: {
		color: "black",
		width: "65%",
		backgroundColor: "white",
		borderRadius: "4px",
		padding: "0 3px",
	},
	who: {
		color: "rgb(0, 145, 125)",
		borderRadius: "3px",
		padding: "0px 5px",
		fontSize: "0.8em",
		textAlign: "right",
	},
};
const TelesecOthersWarningModal = ({ folder, confirmFolderHelpOthers, close }) => {
	return (
		<Modal centered={false} open={confirmFolderHelpOthers} onClose={close}>
			<Modal.Header>Télésecrétariat</Modal.Header>
			<Modal.Content>
				<Modal.Description>
					<Header>Il y a un ou des commentaires par rapport à cette demande.</Header>
					{folder.folderHelp && folder.folderHelp.comments && folder.folderHelp.comments.filter((c) => c.manual).length > 0 && (
						<div>
							<div>Commentaires : </div>
							<div style={{ ...styles.commentsList }}>
								{folder.folderHelp.comments
									.filter((c) => c.manual)
									.slice()
									.sort((a, b) => moment(b.created_at).toDate() - moment(a.created_at).toDate())
									.map((c) => (
										<div style={{ ...styles.commentContainer }} key={`commenthf-${c.id}`}>
											<div style={styles.comment}>
												{c.cancellation && c.cancelReason && (
													<Label tag>
														<span style={{ fontSize: "0.9em" }}>Annulation de la demande de télésecrétariat :</span> {c.cancelReason.label}
													</Label>
												)}
												<div> {c.comment}</div>
											</div>
											<div>
												{c.created_by && (
													<span style={{ ...styles.who }}>
														{c.created_by.first_name} {c.created_by.last_name}
													</span>
												)}
												<span style={{ ...styles.time }}>
													{moment(c.created_at).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`)}
												</span>
											</div>
										</div>
									))}
							</div>
						</div>
					)}
				</Modal.Description>
			</Modal.Content>
			<Modal.Actions>
				<Button onClick={close}>OK</Button>
			</Modal.Actions>
		</Modal>
	);
};
export default TelesecOthersWarningModal;
